// ── Font defaults (core3 font family / variant IDs) ─────────────────

/** System Helvetica (AWPCHelvetica) Regular — matches core3 catalog defaults. */
export const DEFAULT_FONT_ID = 1273
export const DEFAULT_FONT_FAMILY_ID = 61
export const DEFAULT_POINT_SIZE = 14
export const DEFAULT_LEADING = 'auto'
export const DEFAULT_KERNING = 0
export const DEFAULT_TRACKING = 0
/** 0 = left, 1 = center, 2 = right, 3 = justify */
export const DEFAULT_ALIGNMENT = 0

// ── Default text box dimensions (in points) ─────────────────────────

export const DEFAULT_TEXT_BOX_SIZE = { width: 200, height: 60 } as const
